export const QA_NAME_MATCH_ELIGIBILITY_BADGE = 'matchEligibilityBadge'

export const QA_NAME_MATCH_CRITERION_CHIP = 'matchCriterionChip'

export const QA_NAME_MATCH_SCORE_RING = 'matchScoreRing'

export const QA_NAME_MATCH_FIT_CELL = 'matchFitCell'

export const MATCH_ELIGIBILITY = {
  eligible: 'eligible',
  incomplete: 'incomplete',
  notEligible: 'not_eligible',
}

export const MATCH_ELIGIBILITY_STATUSES = {
  [MATCH_ELIGIBILITY.eligible]: {
    text: 'RentalPortal.MatchEligibilityEligibleKey',
    textColor: 'var(--color-success)',
  },
  [MATCH_ELIGIBILITY.incomplete]: {
    text: 'RentalPortal.MatchEligibilityIncompleteKey',
    textColor: 'var(--secondary-text-color)',
  },
  [MATCH_ELIGIBILITY.notEligible]: {
    text: 'RentalPortal.MatchEligibilityNotEligibleKey',
    textColor: 'var(--color-warning)',
  },
}

export const MATCH_CRITERION_STATUS = {
  doesNotFit: 'does_not_fit',
  fits: 'fits',
  notApplicable: 'not_applicable',
  notProvided: 'not_provided',
  partial: 'partial',
}

export const MATCH_CRITERION_STATUSES = {
  [MATCH_CRITERION_STATUS.doesNotFit]: {
    text: 'RentalPortal.MatchStatusDoesNotFitKey',
    textColor: 'var(--color-warning)',
  },
  [MATCH_CRITERION_STATUS.fits]: {
    text: 'RentalPortal.MatchStatusFitsKey',
    textColor: 'var(--color-success)',
  },
  [MATCH_CRITERION_STATUS.notApplicable]: {
    text: 'RentalPortal.MatchStatusNotApplicableKey',
    textColor: 'var(--secondary-text-color-50)',
  },
  [MATCH_CRITERION_STATUS.notProvided]: {
    text: 'RentalPortal.MatchStatusNotProvidedKey',
    textColor: 'var(--secondary-text-color-70)',
  },
  [MATCH_CRITERION_STATUS.partial]: {
    text: 'RentalPortal.MatchStatusPartialKey',
    textColor: 'var(--secondary-text-color)',
  },
}

export const MATCH_VALUE_TYPE = {
  date: 'date',
  durationMonths: 'duration_months',
  enum: 'enum',
  list: 'list',
  money: 'money',
}

export const MATCH_ENUM_LABEL_KEY = {
  income_min: {
    confirmed: 'RentalPortal.MatchValueIncomeConfirmedKey',
    not_confirmed: 'RentalPortal.MatchValueIncomeNotConfirmedKey',
  },
  pets: {
    allowed: 'RentalPortal.MatchValuePetsAllowedKey',
    has_pets: 'RentalPortal.MatchValuePetsYesKey',
    none: 'RentalPortal.MatchValuePetsNoneKey',
    not_allowed: 'RentalPortal.MatchValuePetsNotAllowedKey',
    on_request: 'RentalPortal.MatchValuePetsOnRequestKey',
  },
  wbs: {
    no: 'RentalPortal.MatchValueWbsNoKey',
    not_required: 'RentalPortal.MatchValueWbsNotRequiredKey',
    required: 'RentalPortal.MatchValueWbsRequiredKey',
    yes: 'RentalPortal.MatchValueWbsYesKey',
  },
}

export const MATCH_CRITERION_LABEL_KEY_PREFIX = 'RentalPortal.MatchCriterion'

export const MATCH_REASON_LABEL_KEY_PREFIX = 'RentalPortal.MatchReason'

export const MATCH_ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export const MATCH_SCORE_RING_SIZE = {
  card: 48,
  table: 28,
  tile: 36,
}

export const MATCH_SCORE_REASON_INSUFFICIENT_COVERAGE = 'insufficient_coverage'
